'use strict';

const $ = require('dibs-jquery-shim');
const NC = require('../../global/core/nav/constants');
const tracking = require('dibs-tracking');

const currencySelectTracking = {

    fireCurrencyUpdateTracking(actionContext, payload, done) {
        const { currency } = payload;
        // Currency select is currently visible in footer
        const value = $(NC.HEADER).hasClass(NC.SCROLLED_CLASS) ? 1 : 0;
        const additional = { defaultCurrency: currency + ' Selected' };

        tracking.trackEvent({
            category: 'navigation',
            action: 'footer navigation click',
            label: `change currency|${currency.toLowerCase()}`,
            value: value,
            additional: additional
        });

        done();
    }
};

module.exports = currencySelectTracking;



// WEBPACK FOOTER //
// ./assets/js/components/CurrencySelect/currencySelect-tracking.es.js